import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

const APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';

type GraphQLErrorLike = {
	readonly message?: string | null;
	readonly originalError?: {
		readonly cause?: GraphQLErrorLike | null;
	} | null;
};

type ApolloErrorLike = GraphQLErrorLike & {
	readonly graphQLErrors?: ReadonlyArray<GraphQLErrorLike> | null;
};

const isApprovalsDisabledGraphQLError = (error: GraphQLErrorLike): boolean =>
	Boolean(error.message?.includes(APPROVALS_DISABLED_ERROR_MESSAGE));

export const isApprovalsDisabledError = (
	error: ApolloErrorLike | GraphQLErrorLike | null | undefined,
): boolean => {
	if (!error) return false;

	const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
	if (graphQLErrors?.length) {
		return graphQLErrors.every(isApprovalsDisabledGraphQLError);
	}

	return isApprovalsDisabledGraphQLError(error);
};

const markGraphQLErrorAndCauseAsHandled = (error: GraphQLErrorLike): void => {
	markErrorAsHandled(error);

	const originalCause = error.originalError?.cause;
	if (originalCause && isApprovalsDisabledGraphQLError(originalCause)) {
		markErrorAsHandled(originalCause);
	}
};

export const markApprovalsDisabledErrorAsHandled = (
	error: ApolloErrorLike | GraphQLErrorLike | null | undefined,
): void => {
	if (!error || !isApprovalsDisabledError(error)) {
		return;
	}

	markErrorAsHandled(error);

	const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
	graphQLErrors?.forEach(markGraphQLErrorAndCauseAsHandled);
};
